import { fromJS } from 'immutable';

import * as ACTIONS from  '../containers/constants';

const initialState = fromJS({});

export function friendsReducer(state = initialState, action) {

  switch (action.type) {
    case ACTIONS.GET_FRIENDS:
        return {
        ...state,
        data: action.payload,
        };
    default:
      return state;
  }
}

export default friendsReducer;
